import { render, staticRenderFns } from "./communityList.vue?vue&type=template&id=6521a889&scoped=true&name=referrer&content=no-referrer"
import script from "./communityList.vue?vue&type=script&lang=js"
export * from "./communityList.vue?vue&type=script&lang=js"
import style0 from "./communityList.vue?vue&type=style&index=0&id=6521a889&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6521a889",
  null
  
)

export default component.exports